import React from 'react';
import { CheckCircle, XCircle, Clock } from 'lucide-react';
import { format, parseISO } from 'date-fns';
import type { Transaction } from '../../services/api';

interface RecentActivityProps {
  transactions: Transaction[];
}

const statusIcon = (status: string, type: string) => {
  if (type === 'refund') return <XCircle size={14} className="text-red-400" />;
  if (status === 'success') return <CheckCircle size={14} className="text-emerald-500" />;
  if (status === 'failed') return <XCircle size={14} className="text-red-500" />;
  return <Clock size={14} className="text-yellow-500" />;
};

export const RecentActivity: React.FC<RecentActivityProps> = ({ transactions }) => {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
      <h3 className="text-base font-semibold text-gray-900 mb-3">Recent Transactions</h3>
      <div className="space-y-2">
        {transactions.map(tx => (
          <div key={tx.id} className="flex items-center justify-between py-1.5">
            <div className="flex items-center gap-2 min-w-0">
              {statusIcon(tx.status, tx.type)}
              <div className="min-w-0">
                <div className="text-sm font-medium text-gray-900 truncate">
                  {tx.customer_name || tx.customer_email || 'Unknown'}
                </div>
                <div className="text-xs text-gray-400">
                  {format(parseISO(tx.created_at), 'MMM d, h:mm a')}
                </div>
              </div>
            </div>
            <span className={`text-sm font-semibold flex-shrink-0 ${
              tx.type === 'refund' ? 'text-red-600' : 'text-gray-900'
            }`}>
              {tx.type === 'refund' ? '-' : ''}${Math.abs(tx.amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
